import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  .new-token-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100% !important;
    gap: 24px;
    margin-bottom: 24px;
  }
  .new-token-title {
    color: #000;
    margin-bottom: 20px;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .new-token-subtitle {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
    margin-top: 10px;
    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }
  .new-token-div-juros {
    display: flex;
    justify-content: space-around;
    width: 316px;
  }
  .input-adress-container {
    display: flex;
    justify-content: space-between;
    width: 314.5px;
  }
  .new-token-plus {
    margin-top: 12px;
    color: var(--Cinza-claro, #9c948c);
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }

  @media only screen and (max-width: 1440px) {
    .new-token-container {
      width: 80%;
    }
  }
`

export const FilesContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  display: flex;
  flex-wrap: wrap;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .grey-division-line {
    margin: 24px 0;
    width: 100%;
    border: 1px solid #cccccc80;
  }
`

export const InputError = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  margin: 0 0 15px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #f60665;
`
